<template>

<div>
    <label v-if="titlebefore" class="titlebefore">{{ titlebefore }}</label>
    <label v-html="label" v-if="!placeholder"></label>

      <div v-if="counts.length > 1">
      <input v-for="repeat in counts" :key="repeat" 
        type="text" 
        :placeholder="placeholder ? label : ''"
        
        v-model="inputvalue[repeat-1]"
        @input="update"
    />
      </div>
      <input v-else
        type="text" 
        :placeholder="placeholder ? label : ''"
        :value="value" 
        @input="$emit('update', $event.target.value)"
    />
    <div class="remarks">{{ remarks }}</div>

   
</div>

</template>

<script>
export default {
  props: ["value","label","name","repeats","remarks","titlebefore","placeholder"],
   computed:{
    counts() {
      var repeats = [];
      var r = 1;
      if(this.repeats){
        r = parseInt(this.repeats);
      }
      for(let i = 1; i <= r; i++){
        repeats.push(i)
      }
      return repeats
    },
   
   },
  data: function() {
      return  {
          inputvalue: []
      }
  },
  model: {
    prop: "value",
    event: "update"
  },
  methods:{

    update(){
      
        this.$emit('update', this.inputvalue)
    }
   
  }
};
</script>